import { createContext, useContext, useMemo, useState } from "react";

const CoupangApiStoreInfoValueContext = createContext();
const CoupangApiStoreInfoActionsContext = createContext();

export function CoupangApiStoreInfoContextProvider({ children }) {
    const [coupangApiStoreInfos, setCoupangApiStoreInfos] = useState(null);

    const coupangApiStoreInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setCoupangApiStoreInfos(newValues);
                },
                setValue: setCoupangApiStoreInfos
            }
        },
        []
    )

    return (
        <>
            <CoupangApiStoreInfoActionsContext.Provider value={{ coupangApiStoreInfos: coupangApiStoreInfosActions }}>
                <CoupangApiStoreInfoValueContext.Provider value={{ coupangApiStoreInfos }}>
                    {children}
                </CoupangApiStoreInfoValueContext.Provider>
            </CoupangApiStoreInfoActionsContext.Provider>
        </>
    );
}

export function useCoupangApiStoreInfoValueContextHook(props) {
    const value = useContext(CoupangApiStoreInfoValueContext);

    if (value === undefined) {
        throw new Error('useCoupangApiStoreInfoValueContextHook should be used within CoupangApiStoreInfoValueContext');
    }

    return {
        coupangApiStoreInfos: value.coupangApiStoreInfos
    };
}

export function useCoupangApiStoreInfoActionsContextHook(props) {
    const value = useContext(CoupangApiStoreInfoActionsContext);

    if (value === undefined) {
        throw new Error('useCoupangApiStoreInfoActionsContextHook should be used within CoupangApiStoreInfoActionsContext');
    }

    return {
        coupangApiStoreInfos: {
            onSet: value.coupangApiStoreInfos.onSet,
            setValue: value.coupangApiStoreInfos.setValue
        }
    };
}